import styled from '@emotion/styled';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem;
  margin-bottom: -1rem;
  background-color: ${({ isDarkMode }) => (isDarkMode ? '#000' : '#F3F3F3')};
  width: 100vw;
  z-index: 1201;
  position: relative;
`;

export const HeaderItemContainer = styled.div`
  display: flex;
`;

export const OptionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
